module.exports = __webpack_public_path__ + "static/img/1_2.fe079805.png";